<vw-page [page]="page" [alwaysFillNav]="true" *ngIf="page">
  <vw-page-header>
    <div breadcrumbs>
      <vw-breadcrumbs
        [currentPage]="'checkoutPage.title' | translate"
      ></vw-breadcrumbs>
    </div>
  </vw-page-header>

  <div class="checkout-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-10 mx-auto">
          <div class="row">
            <div class="col-12 my-4">
              <h1 class="fw-light">
                {{ "checkoutPage.title" | translate }}
              </h1>
            </div>
          </div>

          <div class="row shopping-cart-row">
            <div class="col-12 col-sm-10 col-xl-6">
              <div
                class="bg-color-gray-100"
                *ngIf="modelAndDealerService.selectedDealer"
              >
                <div class="card-content">
                  <h4 class="fw-bold mb-3">
                    {{
                      "checkoutPage.dealerAndShipmentInformation" | translate
                    }}
                  </h4>

                  <div class="d-flex align-items-center">
                    <p>
                      <span>
                        {{ "checkoutPage.collectAtDealer" | translate }}
                      </span>
                      <span class="bold">
                        {{ modelAndDealerService.selectedDealer.name }}
                      </span>
                    </p>
                  </div>

                  <vw-dealer-information
                    [dealer]="modelAndDealerService.selectedDealer"
                  ></vw-dealer-information>
                </div>
              </div>

              <div
                class="bg-color-gray-100"
                [class.mt-4]="modelAndDealerService.selectedDealer"
              >
                <div class="card-content">
                  <h4 class="fw-bold mb-3">
                    {{ "checkoutPage.yourInformation" | translate }}
                  </h4>
                  <form [formGroup]="customerInformationForm" autocomplete="on">
                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <vw-text-box
                          [label]="'checkoutPage.firstName' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'first-name'"
                          [type]="'text'"
                          [formControlProp]="'firstName'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.firstName
                              .invalid &&
                            customerInformationForm.controls.firstName.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12 col-lg-6">
                        <vw-text-box
                          [label]="'checkoutPage.lastName' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'last-name'"
                          [type]="'text'"
                          [formControlProp]="'lastName'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.lastName.invalid &&
                            customerInformationForm.controls.lastName.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12">
                        <vw-text-box
                          [label]="'checkoutPage.address' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'address'"
                          [type]="'text'"
                          [formControlProp]="'address'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.address.invalid &&
                            customerInformationForm.controls.address.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12 col-lg-6">
                        <vw-text-box
                          [label]="'checkoutPage.postalCode' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'postal-code'"
                          [type]="'text'"
                          [formControlProp]="'postalCode'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.postalCode
                              .invalid &&
                            customerInformationForm.controls.postalCode.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12 col-lg-6">
                        <vw-text-box
                          [label]="'checkoutPage.city' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'city'"
                          [type]="'text'"
                          [formControlProp]="'city'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.city.invalid &&
                            customerInformationForm.controls.city.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12">
                        <vw-text-box
                          [label]="'checkoutPage.mobilePhone' | translate"
                          [placeholder]="
                            'checkoutPage.mobilePhonePlaceholder' | translate
                          "
                          [parentForm]="customerInformationForm"
                          [id]="'mobile-phone'"
                          [type]="'text'"
                          [formControlProp]="'mobilePhone'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.mobilePhone
                              .invalid &&
                            customerInformationForm.controls.mobilePhone.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12">
                        <vw-text-box
                          [label]="'checkoutPage.email' | translate"
                          [parentForm]="customerInformationForm"
                          [id]="'email'"
                          [type]="'email'"
                          [formControlProp]="'email'"
                          [labelClass]="'primary'"
                          [invalid]="
                            customerInformationForm.controls.email.invalid &&
                            customerInformationForm.controls.email.touched
                          "
                        ></vw-text-box>
                      </div>

                      <div class="col-12">
                        <vw-checkbox
                          [id]="'contact-customer'"
                          [label]="
                            modelAndDealerService.selectedDealer
                              ? ('checkoutPage.contactCustomerDealer'
                                | translate
                                  : {
                                      dealer:
                                        modelAndDealerService.selectedDealer
                                          .name,
                                    })
                              : ('checkoutPage.contactCustomer' | translate)
                          "
                          [parentForm]="customerInformationForm"
                          [formControlProp]="'contactCustomer'"
                        ></vw-checkbox>
                      </div>

                      <div class="col-12">
                        <vw-textarea
                          [parentForm]="customerInformationForm"
                          [formControlProp]="'orderMessage'"
                          [placeholder]="
                            'checkoutPage.orderMessagePlaceholder' | translate
                          "
                          [rows]="5"
                        ></vw-textarea>
                      </div>

                      <div class="col-12">
                        <div class="d-flex justify-content-start">
                          <vw-button
                            [primary]="true"
                            [text]="'save' | translate"
                            [large]="true"
                            (click$)="saveCustomerInformation()"
                            [disabled]="savingCustomer || submitting"
                          ></vw-button>
                        </div>
                      </div>
                      <div
                        class="col-12 col-lg-9 mx-auto"
                        *ngIf="savingCustomer"
                      >
                        <div class="d-flex justify-content-center">
                          <vw-loading></vw-loading>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-sm-10 col-xl-6 mt-4 mt-md-0"
              [class.mb-4]="modelAndDealerService.selectedDealer"
            >
              <div class="bg-color-gray-100 card-content">
                <vw-shopping-cart
                  [showCampaignCodeRow]="true"
                ></vw-shopping-cart>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-10 col-xl-6">
              <div class="bg-color-gray-100 mt-4 mb-4">
                <div class="card-content">
                  <h4 class="fw-bold mb-4">
                    {{ "checkoutPage.order" | translate }}
                  </h4>
                  <div class="d-flex flex-column checkout-footer">
                    <div class="checkout-button">
                      <div class="d-flex justify-content-start mb-3">
                        <vw-link
                          [text]="'FAQ' | translate"
                          [routerLinks]="['/' + themeService.brand, 'faq']"
                          [icon]="'fal fa-long-arrow-right'"
                        ></vw-link>
                        <vw-link
                          class="ms-4"
                          [text]="'terms.title' | translate"
                          [routerLinks]="['/' + themeService.brand, 'terms']"
                          [icon]="'fal fa-long-arrow-right'"
                        ></vw-link>
                      </div>

                      <div class="mb-3">
                        <vw-checkbox
                          [id]="'accept'"
                          [label]="'checkoutPage.accept' | translate"
                          [parentForm]="customerInformationForm"
                          [formControlProp]="'accept'"
                        ></vw-checkbox>
                      </div>

                      <div class="col-12 col-lg-9 mx-auto" *ngIf="submitting">
                        <div class="d-flex justify-content-center">
                          <vw-loading></vw-loading>
                        </div>
                      </div>

                      <div class="d-flex justify-content-start">
                        <vw-button
                          [primary]="true"
                          [text]="'checkoutPage.submit' | translate"
                          [large]="true"
                          (click$)="saveCustomerInformationAndCreateOrder()"
                          [disabled]="
                            submitting ||
                            !modelAndDealerService.selectedDealer ||
                            savingCustomer ||
                            !shoppingCartService.shoppingCart?.shoppingCartItems
                              ?.length ||
                            !customerInformationForm.value.accept
                          "
                        ></vw-button>
                      </div>
                    </div>
                    <div class="checkout-gdpr">
                      <p class="small-message">
                        {{ "checkoutPage.gdpr-message" | translate }}
                      </p>
                      <p class="small-message">
                        {{ "checkoutPage.gdpr-message-2" | translate }}
                        <a
                          class="text-link small-message"
                          href="https://www.vwgroup.se/var-integritetspolicy/"
                          >{{ "checkoutPage.gdpr-message-link" | translate }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</vw-page>
